import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { showToast } from '../../Infrastructure/Notifications/ToastrConfig';
import { resendActivationEmailAsync } from '../../Services/AccountService';
import { ADMIN, userIsInRole } from '../../Services/AuthService';
import { deleteUserAsync, getUserByUrlTokenAsync, updateUserAsync } from '../../Services/UserService';
import Card from '../../Shared/Components/Card/Card';
import Header from '../../Shared/Components/Header/Header';
import Modal from '../../Shared/Components/Modal/Modal';
import PrimaryButton from '../../Shared/Components/PrimaryButton/PrimaryButton';

const User = () => {
    const { urlToken } = useParams();
    const [user, setUser] = useState({ client: { name: "" }, firstName: "", lastName: "", email: "" });
    const [editMode, setEditMode] = useState(false);
    const history = useHistory();

    useEffect(() => {
        const getUser = async () => {
            let response = await getUserByUrlTokenAsync(urlToken);
            setUser(response);
        }
        getUser();
    }, [editMode, urlToken]);

    const updateUser = async () => {
        let respose = await updateUserAsync(user);
        if (respose.success) {
            showToast(true, "User updated");
            setEditMode(false);
        }
        else {
            showToast(false, respose.errors[0].error);
        }
    }

    const deleteUser = async () => {
        let respose = await deleteUserAsync(user);
        if (respose.success) {
            showToast(true, "User deleted");
            history.goBack();
        }
        else {
            showToast(false, respose.errors[0].error);
        }
    }

    const resendConfirmationEmail = async () => {
        let data = {
            userId: user.id
        }
        let response = await resendActivationEmailAsync(data);
        if (response.success) {
            showToast(true, "Email sent")
        }
        else {
            showToast(false, response.errors[0].error)
        }
    }

    const handleChange = evt => {
        setUser({ ...user, [evt.target.name]: evt.target.value });
    }

    return (
        <>
            <Header heading={user.firstName + " " + user.lastName} icon="user" />
            <div className="container-fluid content">
                <Card>
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">
                                <label>First name</label>
                                <input onChange={handleChange} className="form-control" name="firstName" type="text" disabled={!editMode} value={user.firstName} />
                            </div>
                            <div className="form-group">
                                <label>Last name</label>
                                <input onChange={handleChange} className="form-control" name="lastName" type="text" disabled={!editMode} value={user.lastName} />
                            </div>
                            <div className="form-group">
                                <label>Email</label>
                                <input onChange={handleChange} className="form-control" name="email" type="text" disabled={!editMode} value={user.email} />
                            </div>
                            {userIsInRole(ADMIN) &&
                                <div className="form-group">
                                    <label>Client</label>
                                    <input className="form-control" name="client" type="text" disabled={true} value={user.client.name} />
                                </div>
                            }
                            {!editMode ?
                                <PrimaryButton func={() => { setEditMode(true) }} text="Edit" classes="float-right mt-2" />
                                :
                                <>
                                    <PrimaryButton func={updateUser} text="Save" classes="float-right mt-2" />
                                    <PrimaryButton func={() => { setEditMode(false); }} text="Cancel" classes="mr-3 float-right mt-2" />
                                </>
                            }
                            {!editMode ?
                                <>
                                    {!user.emailConfirmed &&
                                        <PrimaryButton classes="mt-2" text="Resend confirmation" func={resendConfirmationEmail} />
                                    }
                                </>
                                :
                                <button data-toggle="modal" data-target={`#delete`} className="btn btn-danger mt-2">Delete</button>
                            }
                        </div>
                    </div>
                </Card>
            </div>
            <Modal buttonFunc={deleteUser}
                modalId={"delete"}
                bodyText="Warning! Deleting users is ireversable! Are you sure you want to delete this user?"
                title={`Delete ${user.firstName} ${user.lastName}`}
                buttonText="Delete"
            />
        </>
    );
};

export default User;